// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class SurveyBreakService {

  constructor() { }
}
